<template>
    <div class="officeDetail">
        <div class="wrap">
            <div class="project-intro">
                <Row>
                    <Col span="16">
                    <swiper-banner style="margin-bottom: 33px;" :imageList="imageList"/>
                    <div class="project-intro-cont">
                        <h3>主导产业</h3>
                        <div class="intro-cont-box">
                            <Row class="box-cy">
                                <Col span="6" :key="item.id" v-for="item in changYeList">
                                 <div class="cy-con">{{item.title}}</div>
                                </Col>
                            </Row>
                        </div>
                        <h3>企业服务</h3>
                        <div class="intro-cont-box">
                            <div class="box-fw">
                                <ul>
                                    <li :key="item.id" v-for="item in fuWuList">{{item.title}}</li>
                                    <!-- <li>企业财税服务</li>
                                    <li>财务审计服务</li>
                                    <li>企业人力服务</li>
                                    <li>企业政策申报</li>
                                    <li>知识产权申请</li>
                                    <li>企业法律服务</li>
                                    <li>企业金融服务</li> -->
                                </ul>
                            </div>
                        </div>
                        <h3>位置信息</h3>
                        <div class="intro-cont-box">
                            <Row class="office-addr">
                                <Col span="12">
                                <!-- <div class="office-map">
                                            <img src="../assets/images/web/office-map.jpg"/>
                                        </div> -->
                                <!-- 高德地图暂时不用 -->
                                <!-- <MapContainer ref="mapContainer" height="400px" @loaded="hanldeMapLoaded">
                                </MapContainer> -->
                                    <img :src="getDiTuUrl">
                                </Col>
                                <Col span="12">
                                <div class="addr-msg">
                                    <ul>
                                        <li>
                                            <div class="iconL">
                                                <Icon type="md-pin" />
                                            </div>
                                            <div class="msgR">
                                                <p>地址</p>
                                                <div>{{ project.address }}</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="iconL">
                                                <Icon type="md-bus" />
                                            </div>
                                            <div class="msgR">
                                                <p>班车</p>
                                                <div>{{ project.vehicle }}</div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="iconL">
                                                <Icon type="md-subway" />
                                            </div>
                                            <div class="msgR">
                                                <p>地铁</p>
                                                <div>地铁13号线中科路站</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    </Col>
                    <Col span="8">
                    <div class="project-introR">
                        <!--<div class="project-cont">
                                <h2>盛大天地·源创谷</h2>
                                <h4>张江科学城内的大型科创园区</h4>
                                <div class="line"><span>&nbsp;</span></div>
                                <div class="dec">
                                <span>项目总建筑面积约15万平米，园区不仅具备完善的商业、商务、文化娱乐设施和青年社区配套，并拥享创新服务平台和盛大全方位优质资源的投入，形成了完善的助推企业发展的全生命周期生态系统。目前，园区内已汇聚了大量互联网、软件开发、芯片研发、智能系统、大数据等行业的优质企业，并入驻一批创新型初创、快速发展企业。未来将始终秉承创新理念，致力于发展成为以互联网、信息科技、文化创意等创新型产业为主，企业发展与人文建设并重的“创新生态之城”。
                                </span>
                                </div>
                            </div>-->
                        <ProjectCont :tit="project.projectName" :msg="project.introduction" :subheading="project.subtitle" />
                        <div class="appoint-box">
                            <Affix :offset-top="70">
                            <AppointmentR v-if="projectId != 0" :msg="appointMsg" :tit="appointTit"
                                :projectId="projectId" :recordType="0"/>
                            </Affix>
                        </div>
                    </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectCont from "../components/ProjectCont";
import AppointmentR from '@/components/AppointmentR.vue';
import swiperBanner from "../components/swiperBanner";
//import MapContainer from '@/components/MapContainer.vue';
export default {
    name: "parkDetail",
    components: {
        AppointmentR,
        swiperBanner,
        ProjectCont,
        //MapContainer,
    },
    data() {
        return {
            projectTit: '盛大天地·源创谷',
            subHeading: '张江科学城内的大型科创园区',
            projectDec: '项目总建筑面积约15万平米，园区不仅具备完善的商业、商务、文化娱乐设施和青年社区配套，并拥享创新服务平台和盛大全方位优质资源的投入，形成了完善的助推企业发展的全生命周期生态系统。目前，园区内已汇聚了大量互联网、软件开发、芯片研发、智能系统、大数据等行业的优质企业，并入驻一批创新型初创、快速发展企业。未来将始终秉承创新理念，致力于发展成为以互联网、信息科技、文化创意等创新型产业为主，企业发展与人文建设并重的“创新生态之城。',
            appointMsg: '填写您的信息，马上入驻盛大天地。',
            appointTit: '预约参观',
            projectId: 0,
            project: {},
            imageList:[],
            changYeList:[],
            fuWuList:[],
        };
    },
    methods: {
        getChangYe() {
            this.loading = true;
            this.$http.get("api/services/app/CommonWeb/GetColumnByName?businessType=1&name=主导产业&businessId="+this.projectId)
                .then(res => {
                    this.changYeList = res.data.result.columnContents;
                    console.log(this.contentList);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getFuWu() {
            this.loading = true;
            this.$http.get("api/services/app/CommonWeb/GetColumnByName?businessType=1&name=企业服务&businessId="+this.projectId)
                .then(res => {
                    this.fuWuList = res.data.result.columnContents;
                    console.log(this.contentList);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getProject() {
            this.loading = true;
            return this.$http.get("/api/services/app/CommonWeb/GetProjectById?id=" + this.projectId)
                .then(res => {
                    this.project = res.data.result;
                    this.project.imageUrlList.forEach(item => {
                        this.imageList.push(item);
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        hanldeMapLoaded({ map, AMap }) {
            console.log(map);
            this.AMap = AMap;
            this.getProject().then(() => {
                var center = new AMap.LngLat(this.project.longitude, this.project.latitude, true);
                let marker = new AMap.Marker({
                    position: center,
                    offset: [0, -10]
                });
                map.add(marker);
                map.setZoomAndCenter(14, center, true, 400);
            })
        },
    },
    computed:{
        //地图url
        getDiTuUrl(){
        return "http://api.tianditu.gov.cn/staticimage?center=121.6050,31.1719&width=350&height=350&zoom=13&layers=vec_c,cva_c&markers="+this.project.longitude+","+this.project.latitude+"&tk=8fbffc7a4eb9a0e195aa60425ca38861"
        }
    },
    mounted() {
        this.projectId = parseInt(this.$route.query.projectId);
        // this.getProject(this.projectId);
        this.getChangYe();
        this.getFuWu();
    },


}
</script>

<style lang="less">
.officeDetail {
    background-color: #fff;
    padding: 30px 0;
    .project-intro {
        .project-intro-cont {
            h3 {
                font-size: 18px;
                margin-bottom: 20px;
            }

            .intro-cont-box {
                margin-bottom: 60px;

                .box-cy {
                    .cy-con {
                        width: 144px;
                        height: 40px;
                        line-height: 38px;
                        text-align: center;
                        font-size: 18px;
                        color: #333;
                        border: 1px solid #E1E3ED;
                        border-radius: 10px;
                    }

                }

                .box-fw {
                    ul {
                        display: flex;
                        flex-flow: row;
                        flex-wrap: wrap;
                        margin-bottom: -15px;
                        padding-left: 20px;

                        li {
                            list-style: disc;
                            width: 25%;
                            padding-bottom: 15px;
                        }

                        li::marker {
                            color: #3377E7;
                            content: unset;
                        }
                    }
                }

                .tit-dec {
                    margin-bottom: -10px;
                    font-size: 14px;

                    .ivu-col-span-6 {
                        margin-bottom: 20px;

                        span {
                            width: 70px;
                            color: #666;

                        }
                    }
                }

                .code-row-bg {
                    text-align: center;
                    margin: 0 -10px;

                    .ivu-col-span-6 {
                        margin-bottom: 20px;

                        .equ {
                            margin: 0 10px;
                            background-color: #fff;
                            border: 1px solid #efefef;
                            border-radius: 5px;

                            img {
                                width: 100%;
                                height: 95px;
                                border-radius: 5px;
                                line-height: 0;
                                display: block;
                            }

                            p {
                                font-size: 14px;
                                line-height: 32px;
                            }
                        }

                        .equ:hover {
                            box-shadow: 0px 0px 2px 0px rgba(70, 139, 254, 0.7);
                        }
                    }
                }

                .office-addr {
                    .office-map {
                        border: 1px solid rgba(0, 0, 0, 0.3);
                        margin-right: 30px;

                        img {
                            width: 100%;
                            height: 100%;
                            line-height: 0;
                            display: block;
                        }
                    }

                    .addr-msg {
                        padding-left: 30px;

                        ul {
                            li {
                                display: flex;
                                align-items: center;
                                margin-bottom: 20px;

                                .iconL {
                                    background-color: #66CFF2;
                                    height: 30px;
                                    line-height: 30px;
                                    width: 30px;
                                    text-align: center;
                                    color: #fff;
                                    font-size: 18px;
                                    border-radius: 5px;
                                    .ivu-icon{
                                        width:30px;
                                    }
                                }

                                .msgR {
                                    margin-left: 10px;
                                    font-size: 14px;

                                    p {
                                        color: #3376FE;
                                        font-size: 12px;
                                    }
                                }
                            }
                        }
                    }
                }

            }
        }

        .project-introR {
            padding-left: 30px;
        }
    }

}
</style>